import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiImage } from '@elastic/eui';
import styled from 'styled-components';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import work2image2 from '../../documents/work2image2.png'
import work2image3 from '../../documents/work2image3.png'

const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-gap: 0 10px;
    padding: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '• ';
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
class Work2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            AlertType: "error",
            entre2Key:['	Project Cost - $ 2.5M','	60+ metric cube of concrete casted ','	15+ concrete cubes tested','	10+ labour managed for concrete casting and rebar tying','	Daily inventory managed for respective site','	Client management – 20+ customers','	Assisted the surveyor for surveying of plot using total station','	1+ tonnage of reinforcement steel checking as per drawing'],
            entre2Value:['	Physical endentre ','Industry Nentre2', ' 5M’s-of Management  '],    
    }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                        <EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>DM Constructions, Satara, India</font></h2></EuiText>
                        <EuiSpacer size='m' />
                        <EuiText><h5><font face='Segoe UI'>(May 2019) (March-June2020)</font></h5></EuiText>
                        <EuiSpacer size='m' />
                <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem grow={true}>
                        <EuiText>
                        <EuiText><b>Position:</b> Summer Intern<EuiSpacer size='m' /> <b>Project:</b> Ishanya Paradise (G+7 Residential Building, Karanje, Satara- 415002</EuiText><EuiSpacer size='m' />
                          <b>Project Highlights</b>
                                  <StyledText><ul className="skills-list">
                                  {this.state.entre2Key && this.state.entre2Key.map((p, i) => <li key={i}>{p}</li>)}
                                  </ul></StyledText>
                                  <b>Value Additions </b>
                                  <StyledText><ul className="skills-list">
                                  {this.state.entre2Value && this.state.entre2Value.map((p, i) => <li key={i}>{p}</li>)}
                                  </ul></StyledText>
                          </EuiText>
                </EuiFlexItem><div><EuiFlexGroup direction='column'>
                <EuiFlexItem ><EuiText textAlign='center'><EuiImage style={{width: '360px', height: '287px'}} src={work2image2} /><br/>
                Formwork Orientation Check</EuiText></EuiFlexItem>
                <EuiFlexItem><EuiText textAlign='center'><EuiImage size='l' src={work2image3} /><br/>
                Concrete On –Site Compliance</EuiText></EuiFlexItem></EuiFlexGroup></div>
                </EuiFlexGroup>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Work2 }